import { generatePath } from "react-router-dom";
import { DashboardRoute } from "./dashboard";

export const baseRoute = "/mein-remindme/wechselservices";
export const baseUrl = `/mein-remindme/wechselservice`;

export const ChangeServiceAuthorizationRoute = "/internal/wechselservice-vollmacht";

export const ElectricityRoute = "/wechselservice/strom";
export const GasRoute = "/wechselservice/gas";

export const EditBaseRoute = "/wechselservice";
export const EditBaseRouteStep = "/:category/:step/:id";

export const baseMissingDataRoute = "/fehlendedaten";
export const MissingDataRoute = "/fehlendedaten/:category/:changeServiceId";
export const MissingContractEndDateRoute = "/fehlendesvertragsende/:category/:changeServiceId";

export const deactivateRoute = `${baseUrl}/:category/deactivate/:id`;
export const getDeactivateRoute = (category: string, id: string) => generatePath(deactivateRoute, { category, id });

export const getMissingDataRoute = (category: string, changeServiceId: string) =>
  generatePath(MissingDataRoute, { category, changeServiceId });

export const withdrawalSubRoute = "/withdrawal";
export const withdrawalRoute = `${baseUrl}/:category${withdrawalSubRoute}/:id`;
export const getWithdrawalRoute = (category: string, id: string) => generatePath(withdrawalRoute, { category, id });

export const overviewURL = ({
  categorySlug,
  fromDashboard = false,
}: {
  categorySlug: string;
  fromDashboard?: boolean;
}) => {
  return `${fromDashboard ? DashboardRoute + EditBaseRoute : EditBaseRoute}/${categorySlug}/ueberpruefen/erstellen`;
};

type Props = {
  categorySlug: string;
};

const defaultProps = {
  categorySlug: ":category",
};

export const changeServices = (props: Props = defaultProps) => {
  const { categorySlug } = props;
  return [baseRoute, categorySlug].join("/");
};

export const ChangeServiceMainPageRoute = EditBaseRoute;
export default changeServices;

export const ChangeServiceRoute = "wechselservice/:category/abschließen";

export const csFormPageStormUrl = "/wechselservice/strom/abschließen";
export const csFormPageGasUrl = "/wechselservice/gas/abschließen";
export const csFormPageHeatpumpUrl = "/wechselservice/heizstrom/abschließen";

export const ChangeServiceRouteNew = "wechselservice/:category/abschließen/:sofId";

export const csFormPageStormUrlNew = "/wechselservice/strom/abschließen/:sofId";
export const csFormPageGasUrlNew = "/wechselservice/gas/abschließen/:sofId";

export const ChangeServiceDetailsRoute = "/mein-remindme/wechselservice/:category/detail/:id";
export const ChangeServiceTariffDetailsRoute = "/mein-remindme/wechselservice/:category/tariff/:id";
export const ChangeServiceTariffHistoryRoute = "/mein-remindme/wechselservice/:category/historie/:id";
export const ChangeServiceEditRoute = "/mein-remindme/wechselservice/:category/bearbeiten/:id";
export const ChangeServiceOverviewRoute = baseRoute;

export const VerifyRoute = "/mein-remindme/wechselservice/:category/daten-ergaenzen/:id";

export const DocumentsRoute = `/mein-remindme/wechselservice/:category/dokumente/:id`;
